import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);
        this.events = {
            click: {
                nav: 'toggleNav',
                // search: 'toggleSearch',
                close: 'close',
                // accessibilite: 'toggleAccessibilite',
                toggleDropdown: 'toggleDropdown',
            }
        }
    }

    init() {
        // this.initBG();
        new ResizeObserver(() => this.initBG()).observe(this.el);
    }

    initBG() {
        let items = this.$('toggleDropdown');
        items.forEach(element => {
            let pos = element.getBoundingClientRect();
            let left = pos.left;
            element.parentNode.querySelector('.c-header_nav_bg').style.left = -left + 'px';
        });
    }

    toggleNav(e) {
        // const burger = this.$('nav')[0];
        const html = document.querySelector('html');
        // const search = this.$('search')[0];
        // search.classList.remove('is-active');
        if(html.classList.contains('has-navOpen')) {
            html.classList.remove('has-navOpen');
            // burger.classList.remove('is-active');
        } else {
            html.classList.remove('has-searchOpen');
            html.classList.add('has-navOpen');
            // burger.classList.add('is-active');
        }
    }

    // toggleSearch(e) {
    //     // const burger = this.$('nav')[0];
    //     // const search = this.$('search')[0];
    //     const html = document.querySelector('html');
    //     // burger.classList.remove('is-active');
    //     if(html.classList.contains('has-searchOpen')) {
    //         html.classList.remove('has-searchOpen');
    //         // search.classList.remove('is-active');
    //     } else {
    //         html.classList.remove('has-navOpen');
    //         html.classList.add('has-searchOpen');
    //         // search.classList.add('is-active');
    //     }
    // }

    close() {
        const html = document.querySelector('html');
        html.classList.remove('has-navOpen');
        html.classList.remove('has-searchOpen');
        
        // const burger = this.$('nav')[0];
        // const search = this.$('search')[0];
        // burger.classList.remove('is-active');
        // search.classList.remove('is-active');
    }

    // toggleAccessibilite(){
    //     if (document.getElementById('pojo-a11y-toolbar').classList.contains('pojo-a11y-toolbar-open')){
    //         document.getElementById('pojo-a11y-toolbar').classList.remove('pojo-a11y-toolbar-open');
    //     } else{
    //         document.getElementById('pojo-a11y-toolbar').classList.add('pojo-a11y-toolbar-open');
    //     }
    // }

    toggleDropdown(e) {
        this.initBG();
        const el = e.currentTarget;
        const html = document.querySelector('html');
        
        let items = this.$('toggleDropdown');

        if (el.classList.contains('is-active')) {
            el.classList.remove('is-active');
            el.parentNode.classList.remove('is-active');
        } else {
            items.forEach(element => {
                element.classList.remove('is-active');
                element.parentNode.classList.remove('is-active');
            }); // close section opened
            el.classList.add('is-active');
            el.parentNode.classList.add('is-active');
        }
    }
}
